/* unplugin-vue-components disabled */import { render } from "./public_heade.vue?vue&type=template&id=38064e24&scoped=true"
import script from "./public_heade.vue?vue&type=script&lang=js"
export * from "./public_heade.vue?vue&type=script&lang=js"

import "./public_heade.vue?vue&type=style&index=0&id=38064e24&scoped=true&lang=css"
import "./public_heade.vue?vue&type=style&index=1&id=38064e24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38064e24"]])

export default __exports__